import { Station } from '@/types'
import { resolveStationName } from '@/utils/stationName'

type Translate = (key: string, options?: Record<string, any>) => string

export function normalizeStationData(data: Station[], t: Translate): any[] {
  return data.map((station, index) => {
    const id = station?.id

    const derivedStationName =
      resolveStationName(station) ||
      (station?.index
        ? t('stationsDefaultStationName', { index: station.index })
        : t('stationsDefaultStationName', { index: index + 1 }))

    const derivedDecoderAddress =
      station?.address !== undefined &&
      station?.address !== null &&
      station?.index !== undefined
        ? `${station.address}-${station.index}`
        : '-'

    const derivedDecoderType =
      (station as any)?.decoderType?.description ||
      (station as any)?.decoderType?.name ||
      station?.decoderType ||
      '-'

    const parsedPriority =
      station?.priority !== null && station?.priority !== undefined
        ? Number(station.priority)
        : undefined

    const priority =
      typeof parsedPriority === 'number' && !Number.isNaN(parsedPriority)
        ? parsedPriority
        : undefined

    const areaName =
      station?.subArea?.parentArea?.name ||
      (station as any)?.area ||
      (station as any)?.areaName ||
      ''

    const subAreaName =
      station?.subArea?.name ||
      (station as any)?.subArea ||
      (station as any)?.subAreaName ||
      ''

    const etZone = station?.etZone?.name || station?.etZone || null
    const etZoneId = station?.etZone?.id || null

    // Stored as a STRING id, like Area's name: the type dropdown offers string
    // options and matches the cell value against them. Every consumer reads it
    // via Number(...), and save maps it back to the numeric Type. Only 1 and 2
    // are types: a stored 0 is blank, not an option called "0" in the dropdown.
    const numericType = Number(station?.stationType)
    const stationType =
      numericType === 1 || numericType === 2 ? String(numericType) : null

    return {
      ...station,
      id,
      description: derivedStationName,
      stationName: derivedStationName,
      decoderAddress: derivedDecoderAddress,
      decoderType: derivedDecoderType,
      area: areaName,
      subArea: station?.subArea ?? subAreaName,
      subAreaId: station?.subArea?.id || null,
      priority,
      etZone,
      etZoneId,
      stationType,
    }
  })
}
